export var labelSizes = {
  "default": {
    paddingSpace: 1
  },
  small: {
    paddingSpace: {
      x: 1,
      y: 0.5
    }
  },
  large: {
    paddingSpace: {
      x: 2,
      y: 1
    }
  }
};
export var labelVariantsBackgrounds = {
  dark: "dark",
  "default": "backgroundDarkLight",
  notify: "notify",
  notifyLight: "notifyLight",
  recommend: "recommend",
  successLight: "successLight",
  successLightWithDarkText: "successLight",
  lightBlue: "lightBlue",
  outlined: null,
  primaryOutlined: null,
  errorLight: "errorLight",
  violetLight: "violetLight",
  disabled: "disabled",
  backgroundLightTint: "backgroundLightTint"
};
export var labelTypography = "nano2";